import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { SessionService } from '@/app/core/services/session';
import { NamedRouter } from '@/app/core/services/named-router';

export const authGuard: CanMatchFn = (route, segments) => {
  const namedRouter = inject(NamedRouter);
  const sessionsService = inject(SessionService);

  if (sessionsService.isAuthenticated()) {
    return true;
  }

  const path = `/${segments.map((segment) => segment.path).join('/')}`;
  const queryParams = namedRouter.getCurrentNavigation()?.extractedUrl.queryParams;

  const queryString =
    queryParams && Object.keys(queryParams).length ? '?' + new URLSearchParams(queryParams).toString() : '';

  const returnUrl = path + queryString;

  sessionsService.navigateToLogin({
    queryParams: {
      returnUrl: returnUrl || null,
    },
  });

  return false;
};
